import { render, staticRenderFns } from "./goodsClass.vue?vue&type=template&id=1665124c&scoped=true&"
import script from "./goodsClass.vue?vue&type=script&lang=js&"
export * from "./goodsClass.vue?vue&type=script&lang=js&"
import style0 from "./goodsClass.vue?vue&type=style&index=0&id=1665124c&prod&lang=css&"
import style1 from "./goodsClass.vue?vue&type=style&index=1&id=1665124c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665124c",
  null
  
)

export default component.exports